import { Buffer } from 'buffer'
const ENCODING = 'base64'

export const setLocalStorage = (key: string, data: any) =>
    localStorage.setItem(
        key,
        Buffer.from(JSON.stringify(data)).toString(ENCODING)
    )

export const getLocalStorage = (key: string) => {
    const item = localStorage.getItem(key)
    if (item !== null) {
        return JSON.parse(Buffer.from(item, ENCODING).toString())
    }
    return null
}

export const removeLocalStorage = (key: string) =>
    sessionStorage.removeItem(key)

export const setSessionStorage = (key: string, data: any) =>
    sessionStorage.setItem(
        key,
        Buffer.from(JSON.stringify(data)).toString(ENCODING)
    )

    export const setSessionStorage2 = (key: string, data: any) =>
    sessionStorage.setItem(
        key,
        data
    )

export const getSessionStorage = (key: string) => {
    const item = sessionStorage.getItem(key)
    if (item !== null) {
        return JSON.parse(Buffer.from(item, ENCODING).toString())
    }
    return null
}

export const removeSessionStorage = (key: string) =>
    sessionStorage.removeItem(key)

export const clearAll = () => {
    localStorage.clear()
    sessionStorage.clear()
}
